'use strict';

var react = require('@emotion/react');

const qualityBadge = /*#__PURE__*/ react.css({
    height: "24px",
    width: "24px"
}, "label:label-QualityBadge-web-stylesqualityBadge", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2JlbmFpYWhiYXJhbmdvL2Rldi9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9wbGF0Zm9ybS9RdWFsaXR5QmFkZ2UvUXVhbGl0eUJhZGdlLndlYi5zdHlsZXMudHMiLCJzb3VyY2VzIjpbIi9Vc2Vycy9iZW5haWFoYmFyYW5nby9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvcGxhdGZvcm0vUXVhbGl0eUJhZGdlL1F1YWxpdHlCYWRnZS53ZWIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5leHBvcnQgY29uc3QgcXVhbGl0eUJhZGdlID0gY3NzKHtcbiAgaGVpZ2h0OiBcIjI0cHhcIixcbiAgd2lkdGg6IFwiMjRweFwiLFxufSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTRCIn0= */");

exports.qualityBadge = qualityBadge;
//# sourceMappingURL=QualityBadge.web.styles.cjs.map
